// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationModal-cls1__e7729757cbfbf8016781","cls2":"ConfirmationModal-cls2__bbb185a98e7b449203b0 ConfirmationModal-cls1__e7729757cbfbf8016781"};